import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type AttachmentDropOverlayProps = {
  label: string;
};

export default function AttachmentDropOverlay({ label }: AttachmentDropOverlayProps) {
  const theme = useTheme();

  return (
    <Box
      data-test-id="attachment-drop-overlay"
      sx={{
        alignItems: 'center',
        bgcolor: theme.brandV2.colors.treadGray9,
        border: `1px dashed ${theme.brandV2.colors.treadBlue}`,
        borderRadius: theme.brandV2.borderRadius,
        display: 'flex',
        inset: 0,
        justifyContent: 'center',
        opacity: 0.95,
        pointerEvents: 'none',
        position: 'absolute',
        zIndex: 1,
      }}
    >
      <Typography
        sx={{
          color: theme.brandV2.colors.treadBlue,
          fontSize: '13px',
          fontWeight: 600,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
